/**
 * i18n bridge — delegates to the real vue-i18n instance.
 * Used by core modules (e.g. api.ts) that cannot import vue-i18n directly.
 * The import is safe because vue-i18n is created synchronously in plugins/i18n.ts,
 * and this module's functions are only called at runtime (after app initialization).
 */
import { i18n as vueI18n } from '@/plugins/i18n'

export const i18n = {
  t(key: string, params: Record<string, unknown> = {}): string {
    return (vueI18n.global.t as (k: string, p: Record<string, unknown>) => string)(key, params)
  },
}
